export const SOLUTIONS = {
  finance: [
    {
      title: "Track Your Spending",
      desc: "Use a simple worksheet or free app to see where your money goes and spot savings opportunities.",
      link: "http://mint.intuit.com/"
    },
    {
      title: "Financial Counseling (Germany)",
      desc: "Find a certified advisor near you for free, confidential advice.",
      link: "https://beratung.diakonie.de/schuldnerberatung-und-insolvenzberatung/registration?postcode=09366"
    }
  ],
  breakup: [
    {
      title: "Guided Meditation for Healing",
      desc: "A gentle meditation to help process breakup pain and find calm.",
      link: "https://www.youtube.com/watch?v=niU8KDtQRdg"
    },
    {
      title: "Talk to Someone",
      desc: "Free helpline for emotional support. You're not alone.",
      link: "tel:08001110111"
    }
  ],
  anxiety: [
    {
      title: "Breathing Exercise",
      desc: "Try the 4-7-8 technique: Breathe in for 4 seconds, hold for 7, out for 8.",
      link: "https://www.youtube.com/watch?v=YRPh_GaiL8s"
    },
    {
      title: "Guided Mindfulness",
      desc: "A 5-minute grounding meditation for anxiety relief.",
      link: "https://www.youtube.com/watch?v=O-6f5wQXSu8"
    },
    {
      title: "Professional Help",
      desc: "If anxiety persists, consider reaching out to a mental health professional online or in-person.",
      link: "https://www.betterhelp.com/"
    }
  ],
  stress: [
    {
      title: "Progressive Muscle Relaxation",
      desc: "Release tension from your body with this easy guided exercise.",
      internal: "/tools/relaxation"
    },
    {
      title: "Quick De-Stress",
      desc: "A 3-minute routine to reset your mind and body.",
      internal: "/tools/quick-destress"
    }
  ],
  loneliness: [
    {
      title: "Join a Community",
      desc: "Find local or online groups with shared interests, especially for expats and women.",
      link: "https://www.meetup.com/"
    },
    {
      title: "Volunteer",
      desc: "Helping others is a great way to connect and feel purposeful.",
      link: "https://www.volunteermatch.org/"
    }
  ],
  burnout: [
    {
      title: "Set Boundaries & Prioritize Rest",
      desc: "Define clear work and personal time. Give yourself permission to rest without guilt.",
      link: "https://www.pwp.health/services/expat-mental-health"
    },
    {
      title: "Connect with Supportive Communities",
      desc: "Reach out to other expats or local groups—shared experiences help you feel less alone.",
      link: "https://www.theexpatwoman.com/mentalhealthabroad/"
    },
    {
      title: "Practice Self-Care & Mindfulness",
      desc: "Try daily self-care: walks, journaling, or mindfulness meditation to recharge.",
      link: "https://positivepsychology.com/burnout-prevention/"
    },
    {
      title: "Seek Professional Help if Needed",
      desc: "If burnout feels overwhelming, talk to a mental health professional familiar with expat challenges.",
      link: "https://www.pwp.health/services/expat-mental-health"
    },
    {
      title: "Maintain Social Connections",
      desc: "Stay in touch with friends and family back home, and nurture new friendships locally.",
      link: "https://onlinelibrary.wiley.com/doi/10.1155/2016/9730162"
    }
  ],
  // ...rest of your categories unchanged
};
